import { getRenderableWebsiteUrl } from "../../shared/websiteUrl.js";

export function MarketExternalLinks({ xUrl, websiteUrl, className = "" }) {
  const safeWebsiteUrl = getRenderableWebsiteUrl(websiteUrl);

  if (!xUrl && !safeWebsiteUrl) {
    return null;
  }

  return (
    <div className={["flex items-center gap-2", className].join(" ").trim()}>
      {xUrl ? (
        <a
          href={xUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="X profile"
          title="X profile"
          className="text-blue-400 hover:text-blue-300"
        >
          <XIcon />
        </a>
      ) : null}
      {safeWebsiteUrl ? (
        <a
          href={safeWebsiteUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Website"
          title="Website"
          className="text-blue-400 hover:text-blue-300"
        >
          <WebsiteIcon />
        </a>
      ) : null}
    </div>
  );
}

function XIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true">
      <path d="M18.901 1.153h3.68l-8.04 9.19 9.458 12.504h-7.406l-5.802-7.584-6.639 7.584H.47l8.598-9.826L0 1.154h7.594l5.245 6.932 6.062-6.933Z" />
    </svg>
  );
}

function WebsiteIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true">
      <path d="M12 2a10 10 0 1 0 10 10A10.012 10.012 0 0 0 12 2Zm6.93 9h-3.35a15.7 15.7 0 0 0-1.2-5.1A8.03 8.03 0 0 1 18.93 11ZM12 4.07c.86 1.13 1.91 3.47 2.2 6.93H9.8C10.09 7.54 11.14 5.2 12 4.07ZM4.07 13h3.35a15.7 15.7 0 0 0 1.2 5.1A8.03 8.03 0 0 1 4.07 13Zm3.35-2H4.07a8.03 8.03 0 0 1 4.55-5.1A15.7 15.7 0 0 0 7.42 11Zm1.39 2h6.38c-.29 3.46-1.34 5.8-2.2 6.93-.86-1.13-1.91-3.47-2.2-6.93Zm5.57 5.1a15.7 15.7 0 0 0 1.2-5.1h3.35a8.03 8.03 0 0 1-4.55 5.1Z" />
    </svg>
  );
}
